import React from 'react';

export const StateLabel = ({
  state,
  color,
}: {
  state: string;
  color: string;
}) => (
  <>
    <span className={`State state color-${color}`}>{state}</span>
    <style jsx>{`
      .State {
        font-weight: 800;
      }
    `}</style>
  </>
);
